export default "__VITE_ASSET__$_zPR9Fr__"